<template>
  <v-dialog v-model="dialog" :overlay=false>
    <v-card>
      <v-card-title>
        <div class="headline">Procedere con la cancellazione?</div>
      </v-card-title>
      <v-card-text>
        {{message}}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat primary @click.native="close(false)">Annulla</v-btn>
        <v-btn flat primary @click.native="close(true)">Ok</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * Crea un dialog di conferma prima di cancellare
 * @module components/common/ConfirmDelete
 */
export default {
    name: 'confirmDelete',
    methods: {
      close (result) {
        this.$emit('close', result)
      }
    },
    computed: {
      dialog: {
        get () {
          return this.confirm != null
        },
        set () {
          this.$emit('close', false)
        }
      }
    },
    /**
     * @prop confirm {object} - L'oggetto da eliminare 
     * @prop message {string} - Il contenuto del dialog
     */
    props: ['confirm', 'message']
}
</script>


// WEBPACK FOOTER //
// src/components/common/ConfirmDelete.vue